const baseUrl = "https://rawosapi.gitwork-team.com/api/v1/";


export { baseUrl };